import { LANGUAGE_MAP } from "../contants";
import { getSiteInfo } from "./get-site-info";

/** getSiteInfo plus the per-country flags; what useSiteInfo returns, for server code. */
export const getSiteFlags = (locale: string) => {
  const siteInfo = getSiteInfo(locale);

  return {
    ...siteInfo,
    isUS: siteInfo?.iso === LANGUAGE_MAP.US,
    isIN: siteInfo?.iso === LANGUAGE_MAP.IN,
    isCA: siteInfo?.iso === LANGUAGE_MAP.CA,
    isFC: siteInfo?.iso === LANGUAGE_MAP.FC,
    isKR: siteInfo?.iso === LANGUAGE_MAP.KR,
    isJP: siteInfo?.iso === LANGUAGE_MAP.JP,
    isPL: siteInfo?.iso === LANGUAGE_MAP.PL,
    isNL: siteInfo?.iso === LANGUAGE_MAP.NL,
    isES: siteInfo?.iso === LANGUAGE_MAP.ES,
    isGE: siteInfo?.iso === LANGUAGE_MAP.GE,
    isLA: siteInfo?.iso === LANGUAGE_MAP.LA,
    isUK: siteInfo?.iso === LANGUAGE_MAP.UK,
    isSE: siteInfo?.iso === LANGUAGE_MAP.SE,
    isNO: siteInfo?.iso === LANGUAGE_MAP.NO,
    isIT: siteInfo.iso === LANGUAGE_MAP.IT,
    isAU: siteInfo.iso === LANGUAGE_MAP.AU,
  };
};

export type SiteFlags = ReturnType<typeof getSiteFlags>;
